<app-contact-filters
  (onFilter)="onFilter($event)"
  [defaultFilters]="defaultFilters"
>
</app-contact-filters>
<mat-card class="u-center-text" *ngIf="!(contacts | async).length">
  <h4>{{ 'contacts.Nessun contatto trovato' | translate}}</h4>
  <button *ngIf="canAdd" mat-raised-button (click)="addContact()">
    {{ 'shared.Aggiungi' | translate}}
  </button>
</mat-card>
<div class="table-container" [hidden]="!(contacts | async).length">
  <table
    mat-table
    matSort
    [dataSource]="contacts"
    matSortDisableClear
    matSortActive="lastname"
    matSortDirection="asc"
  >
    <ng-container matColumnDef="lastname">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'shared.Cognome' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.lastname }}
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'shared.Nome' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'shared.Email' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.email }}
      </td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.Telefono' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.phone }}
      </td>
    </ng-container>
    <ng-container matColumnDef="mobile">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'shared.Cellulare' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.mobile }}
      </td>
    </ng-container>
    <ng-container matColumnDef="fax">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.Fax' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.fax }}
      </td>
    </ng-container>
    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef>{{ 'shared.Note' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon *ngIf="row.note" [matTooltip]="row.note">note</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <button
          *ngIf="canAdd"
          mat-icon-button
          mat-raised-button
          color="accent"
          (click)="$event.stopPropagation(); addContact()"
        >
          <mat-icon matTooltip="{{'shared.Aggiungi' | translate}}">playlist_add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="canEdit">
          <button
            mat-menu-item
            (click)="$event.stopPropagation(); editContact(row)"
          >
            <mat-icon matTooltip="{{ 'shared.Modifica' | translate}}">create</mat-icon>
          </button>
        </ng-container>
        <button
          *ngIf="canSelect"
          mat-raised-button
          color="primary"
          (click)="selectContact(row)"
        >
        {{ 'shared.Seleziona' | translate}}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSizeOptions[0]"
    [length]="total | async"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
